import React, { FunctionComponent } from 'react';

import Block from '@views/components/block/Block';
import EmptyState from '@views/components/emptystate';

import ProductList from './components/product-list';
import Placeholder from './placeholder';

import { useProductList } from './hooks/use-product-search';
import _convertUrl from '@helpers/convert-to-url';
import _arrayToString from '@helpers/array-to-string';
import { TITLE, EMPTY_STATE } from './intl';

const PAGE_SIZE = 24;
import styled from 'styled-components';

const BlockTitle = styled(Block.Title)`
  text-transform: uppercase;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  padding: 0 1.425rem;
  display: flex;
  align-items: center;
`;

const BlockHeader = styled(Block.Header)`
  border: 1px solid var(--gray-light);
  border-radius: var(--radius) var(--radius) 0 0;
`;

export const Container: FunctionComponent<any> = () => {
  const { products, loading, error } = useProductList({
    page: 1,
    limit: PAGE_SIZE,
    orderBy: 'price|asc',
    categoryId: 310,
  });

  if (loading || error) {
    return <Placeholder />;
  }

  return (
    <Block isSection>
      <BlockHeader className="pb-3">
        <BlockTitle>{TITLE}</BlockTitle>
      </BlockHeader>

      {products.size > 0 ? (
        <ProductList data={products} />
      ) : (
        <EmptyState title={EMPTY_STATE.TITLE} message={EMPTY_STATE.MESSAGE} />
      )}
    </Block>
  );
};

export default Container;
